import constants from '@/constants';
import { axiosRequest, METHOD } from '@/api/default.js';

export async function getDailyFileUploads(params) {
    return await axiosRequest({
        url: constants.URL.SYSTEM_ANALYTICS_DAILY_FILE_UPLOADS,
        method: METHOD.GET,
        requestName: 'GET DAILY FILE UPLOADS',
        params,
        isLoader: false,
    });
}
